import * as React from 'react';
import { forwardRef, Fragment } from 'react';
import classNames from 'classnames';
import { CnIcon } from '@/components/cn-icon';
const Media = (props, ref) => {
    const { action, prefix = 'cn-ui-m-', icon, children, className, ...others } = props;
    return (React.createElement("div", { ref: ref, ...others, className: classNames(`${prefix}list-item-media`, action ? `${prefix}list-item-media--last` : null, className) },
        icon ? (React.createElement(CnIcon, { className: `${prefix}list-item-icon`, type: icon })) : null,
        React.createElement(Fragment, null, children)));
};
export const CnListItemMedia = forwardRef(Media);
const Action = (props, ref) => {
    return React.createElement(CnListItemMedia, { ...props, action: true, ref: ref });
};
export const CnListItemAction = forwardRef(Action);
export default CnListItemMedia;
